import { useState, useEffect } from 'react';
import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionLabel from 'components/typography/SectionLabel';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_TOUR } from 'shared/constants/common';
import ToursItem from './ToursItem';

export default function Tours({ toursList = [] }) {
  const [isLoyaltyTour, setIsLoyaltyTour] = useState(false);
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();

  useEffect(() => {
    const foundLoyalty = toursList.some(tour => tour.loyalty === true);
    setIsLoyaltyTour(foundLoyalty);
  }, [toursList]);

  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_TOUR}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionLabel label={isLoyaltyTour ? "Bundles" : "Tours"} className="ml-[10px] mt-1" />
      </div>
      {toursList.map((tour, index) => (
        <div key={`${index + 1}`} className="mt-[40px]">
          <ToursItem tour={tour} isLoyaltyTour={isLoyaltyTour} />
        </div>
      ))}
    </>
  );
}
